export const isIntercomAvailable = () => !!(window && window.Intercom);
